import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { PaymentProvider } from './context/PaymentContext';
import Layout from './components/common/Layout';
import ProtectedRoute from './components/common/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import NakshatraLanding from './pages/NakshatraLanding';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Verify from './pages/Verify';
import SubscriptionPlans from './pages/SubscriptionPlans';
import PaymentReturn from './pages/PaymentReturn';
import IndianAstrology from './pages/IndianAstrology';
import Horoscope from './pages/Horoscope';
import Palmistry from './pages/Palmistry';
import Profile from './pages/Profile';
import Compatibility from './pages/Compatibility';
import Chat from './pages/Chat';
import PrivacyPolicy from './pages/PrivacyPolicy';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <PaymentProvider>
          <Router>
            <Layout>
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<NakshatraLanding />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/verify" element={<Verify />} />
                <Route path="/plans" element={<SubscriptionPlans />} />
                <Route path="/indian-astrology" element={<IndianAstrology />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                
                {/* Protected Routes */}
                <Route path="/horoscope" element={
                  <ProtectedRoute>
                    <Horoscope />
                  </ProtectedRoute>
                } />
                <Route path="/profile" element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                } />
                <Route path="/payment" element={
                  <ProtectedRoute>
                    <Palmistry />
                  </ProtectedRoute>
                } />
                <Route path="/palmistry" element={
                  <ProtectedRoute>
                    <Palmistry />
                  </ProtectedRoute>
                } />
                <Route path="/compatibility" element={
                  <ProtectedRoute>
                    <Compatibility />
                  </ProtectedRoute>
                } />
                <Route path="/chat" element={
                  <ProtectedRoute>
                    <Chat />
                  </ProtectedRoute>
                } />
                
                {/* Payment Routes */}
                <Route path="/payment/return" element={<PaymentReturn />} />
                
                {/* Fallback */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </Router>
        </PaymentProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
